import { ErrorOutline } from '@mui/icons-material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import awsRum from '../../../../../awsRum';
import StyledBox from './styles';

function ErrorFallback(props: FallbackProps) {
  const { error, resetErrorBoundary } = props;
  const { t } = useTranslation();

  return (
    <StyledBox>
      <Box>
        <ErrorOutline />
        <Typography>
          {t('error.text')}
        </Typography>
        <Typography>
          {error.message}
        </Typography>
        <Button onClick={resetErrorBoundary}>
          <RefreshIcon />
          {t('error.try-again')}
        </Button>
      </Box>
    </StyledBox>
  );
}

export default function PageErrorBoundary(props: { children: React.ReactNode }) {
  const { children } = props;
  return (
    <ErrorBoundary
      resetKeys={[children]}
      FallbackComponent={ErrorFallback}
      onError={(error: Error) => {
        awsRum?.recordError(error);
        console.error(error);
      }}
    >
      {children}
    </ErrorBoundary>
  );
}
